// Handle weapon attachment targeting - Two-step process

const attachWeapon = (targetUnit, ws, setError, setWeaponTargetMode, selectedWeaponId, setSelectedWeaponId, selectedWeaponInstanceId, gameId, userId, gameState, setWeaponDeployTargetMode, setWeaponDeployTargetInfo) => {
  
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  if (!targetUnit) {
    setError("No target unit selected");
    return;
  }

  // Tutorial overlay: only allow attaching to units in allowedWeaponAttachTargetOrderIds (e.g. only Opportunist 302)
  if (typeof document !== 'undefined' && document.body) {
    const attr = document.body.getAttribute('data-tutorial-overlay-weapon-attach-restrict');
    if (attr) {
      try {
        const allowed = JSON.parse(attr);
        if (Array.isArray(allowed) && allowed.length > 0) {
          const allowedSet = new Set(allowed.map(a => Number(a)));
          const targetOrderId = targetUnit.id ?? targetUnit.orderId;
          const targetZone = targetUnit.zone != null ? String(targetUnit.zone) : '';
          const isOpponentUnit = targetZone.startsWith('opponent_');
          if (isOpponentUnit) {
            setError('In this step you can only attach the weapon to the indicated unit');
            if (typeof setWeaponTargetMode === 'function') setWeaponTargetMode(false);
            if (typeof setSelectedWeaponId === 'function') setSelectedWeaponId(null);
            if (typeof setSelectedWeaponInstanceId === 'function') setSelectedWeaponInstanceId(null);
            if (typeof setWeaponDeployTargetMode === 'function') setWeaponDeployTargetMode(false);
            if (typeof setWeaponDeployTargetInfo === 'function') setWeaponDeployTargetInfo(null);
            return;
          }
          if (targetOrderId == null || !allowedSet.has(Number(targetOrderId))) {
            setError('In this step you can only attach the weapon to the indicated unit');
            if (typeof setWeaponTargetMode === 'function') setWeaponTargetMode(false);
            if (typeof setSelectedWeaponId === 'function') setSelectedWeaponId(null);
            if (typeof setSelectedWeaponInstanceId === 'function') setSelectedWeaponInstanceId(null);
            if (typeof setWeaponDeployTargetMode === 'function') setWeaponDeployTargetMode(false);
            if (typeof setWeaponDeployTargetInfo === 'function') setWeaponDeployTargetInfo(null);
            return;
          }
        }
      } catch (_) {}
    }
  }

  // Step 1: Send weapon attachment action
  const action = {
    type: "attachWeapon",
    gameId: gameId,
    weaponInstanceId: selectedWeaponInstanceId,
    targetUnitInstanceId: targetUnit.instanceId,
    targetZone: targetUnit.zone,
    targetIndex: targetUnit.index
  };

  ws.send(JSON.stringify(action));
  
  // Don't reset targeting yet - wait for server response
  // The server will respond with needsDeployTargeting flag
};

// Handle weapon deploy targeting (Step 2)
const weaponDeployTarget = (targetUnit, ws, setError, weaponDeployTargetInfo, gameId) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  if (!weaponDeployTargetInfo) {
    setError("No weapon deploy target info available");
    return;
  }

  if (!targetUnit) {
    setError("No target unit selected for deploy effect");
    return;
  }

  // Tutorial overlay: weaponDeployTargetAllowOnly — only allow listed unit order IDs (e.g. Tranquilizer 333 → Malignant Berserker 3)
  if (typeof document !== 'undefined' && document.body) {
    const attr = document.body.getAttribute('data-tutorial-overlay-weapon-deploy-restrict');
    if (attr) {
      try {
        const overlay = JSON.parse(attr);
        const weaponId = weaponDeployTargetInfo?.weaponId;
        if (weaponId != null) {
          const allowed = overlay[String(weaponId)] ?? overlay[weaponId];
          if (Array.isArray(allowed) && allowed.length > 0) {
            const allowedSet = new Set(allowed.map(a => Number(a)));
            const targetOrderId = targetUnit.id ?? targetUnit.orderId;
            if (targetOrderId == null || !allowedSet.has(Number(targetOrderId))) {
              setError('In this step you can only target the indicated unit with this weapon');
              return;
            }
          }
        }
      } catch (_) {}
    }
  }

  // Send weapon deploy target action
  const action = {
    type: "weaponDeployTarget",
    gameId: gameId,
    weaponInstanceId: weaponDeployTargetInfo.weaponInstanceId,
    deployTargets: [{
      targetUnitInstanceId: targetUnit.instanceId,
      targetZone: targetUnit.zone,
      targetIndex: targetUnit.index
    }]
  };

  ws.send(JSON.stringify(action));
  setError('');
};

export default attachWeapon;
export { weaponDeployTarget };
